// extracted by mini-css-extract-plugin
export default {"navigation":"Navigation_navigation__GZGIL","navigation__link":"Navigation_navigation__link__BRKHP"};